
import React, { useState, useEffect, useRef } from 'react';
import Cookies from 'js-cookie';
import { Button } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import Logo from './logo.png';
import moment from 'moment-timezone';
import { provinceTaxes } from '../../constants/taxes';
import shortid from 'shortid';
import { getCoordinates } from '../../util/address';

import {
  Container,
  Row,
  Col,
  ApiUrl,
  toast,
  Axios,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from '../index';
import { getTimezone } from '../../../src/actions/helper';
import axios from 'axios';
import { API_GET_PHARMACY_DETAILS, API_URL, API_VERSION, API_CREATE_MYRX_CREATE_ORDER, API_CREATE_GOLIVRO_DELIVERY } from '../../ApiUrl';
const MISSING_PROVINCE_TOAST_ID = "missingProvinceToast";


const fetchPharmacyDetails = async () => {
  axios.get(API_GET_PHARMACY_DETAILS, {
    baseURL: `${API_URL}${API_VERSION}`,
    headers: {
      token: Cookies.get("token"),
      restaurantid: Cookies.get("_id"),
    },
  }).then((response) => {
    let data = response.data;

    if (data) {
      data = data.data;
      Cookies.set('featureAccess', data.featureAccess);
      Cookies.set("province", data.province);
    }
  }).catch((error) => {
    console.error('Error fetching pharmacy details:', error);
  });
};
export function getPriceWithoutTax(total) {
  const province = Cookies.get("province");
  const provinceTax = provinceTaxes[province] || 0;

  if (!provinceTax) {
    if (!toast.isActive(MISSING_PROVINCE_TOAST_ID)) {
      toast.error("Invalid or missing province tax rate, Refresh and try again.", {
        toastId: MISSING_PROVINCE_TOAST_ID,
        autoClose: 5000,
      });
    }
    return 0;
  }

  const subTotal = total / (1 + provinceTax / 100);
  return (subTotal / 100).toFixed(2);
}
function getPrescriptionNumbers(delivery) {
  const prescriptionNumberKeys = [];
  for (let i = 0; i < Number(delivery.numberOfPrescriptions); i++) {
    prescriptionNumberKeys.push(`prescriptionNumber${i + 1}`);
  }
  return prescriptionNumberKeys.map((key) => delivery[key]);
}
function formatNumberCanadian(number) {
  const cleaned = ('' + number).replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return match[1] + '-' + match[2] + '-' + match[3];
  }
  if (number.startsWith('+')) {
    const cleaned2 = ('' + number).replace(/\D/g, '');
    const match2 = cleaned2.match(/^(\d{1})(\d{3})(\d{3})(\d{4})$/);
    if (match2) {
      return '+' + match2[1] + match2[2] + '-' + match2[3] + '-' + match2[4];
    }
  }
  return number;
}

// ========== UBER REVIEW MODAL ==========
function UberReviewModal({
  modal,
  toggle,
  deliveries,
  isAfter7pm,
  deliveryCharges,
  redirectPage,
  activeVendor,
  storePostalCode,
  storeProvince,
  lastScheduledDate
}) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const isSubmittingRef = useRef(false);
  const [pharmacyLoaded, setPharmacyLoaded] = useState(false);

  let total = 0;
  if (deliveryCharges && Array.isArray(deliveryCharges)) {
    total = deliveryCharges.reduce(
      (sum, { fee }) => sum + Number(getPriceWithoutTax(fee)),
      0
    );
  }
  const invalidDeliveryCharge = deliveryCharges && deliveryCharges.some(
    ({ fee }) => !fee || Number(fee) === 0
  );

  function hasScheduled(delivery) {
    return (
      delivery &&
      delivery.scheduled &&
      delivery.scheduled.length > 0
    );
  }

  function getScheduledDateUber(delivery) {
    const parsedDate = moment(delivery.scheduledDate, moment.ISO_8601, true);
    return parsedDate.isValid() ? parsedDate : null;
  }

  async function submitOrders(printLabel = false) {
    try {
      // Prevent rapid double submissions before state updates take effect
      if (isSubmittingRef.current) {
        toast.info(t('orderInProgress'));
        return;
      }
      isSubmittingRef.current = true;
      setLoading(true);
      const loadingToastId = toast.info(t('submittingOrder'), { autoClose: false });

      const { API_SUBMIT_ORDERS } = ApiUrl;
      const orders = deliveries.map((delivery, idx) => {
        if (
          delivery.recurring &&
          delivery.recurring.length > 0 &&
          !(delivery.ends && delivery.ends.length > 0)
        ) {
          const endDate = moment().add(6, 'months');
          delivery.ends = ['ends'];
          delivery.endDate = endDate.toISOString();
        }
        if (!delivery.requestId) {
          delivery.requestId = shortid.generate();
        }
        const prescriptionNumbers = getPrescriptionNumbers(delivery);
        const scheduledDate = getScheduledDateUber(delivery);

        return {
          cellPhoneNumber: delivery.phone,
          address: delivery.address.address,
          zipCode: delivery.address.zipCode,
          patientName: delivery.patientName,
          apptOrUnitType: delivery.apptOrUnitType,
          apptOrUnit: delivery.apptOrUnit,
          deliveryNotes: delivery.deliveryNotes,
          pickupNotes: delivery.pickupNotes,
          proofOfDelivery: delivery.proofOfDelivery,
          proofOfReturnDelivery: delivery.proofOfReturnDelivery,
          proofOfPickup: delivery.proofOfPickup,
          numberOfPrescriptions: delivery.numberOfPrescriptions,
          prescriptionNumbers,
          storePostalCode,
          deliveryFee: deliveryCharges[idx].fee,
          orderSubTotal: deliveryCharges[idx].fee,
          pharmacyId: Cookies.get('_id'),
          scheduled: delivery.scheduled,
          scheduledDate: scheduledDate ? scheduledDate.toISOString() : "",
          nextRecurrenceDate: delivery.nextRecurrenceDate,
          costs: delivery.costs,
          recurring: delivery.recurring,
          recurrence: delivery.recursion,
          customRecurringDays: delivery.customRecurringDays,
          customRecurringDaysOrderTime: delivery.customRecurringDaysOrderTime,
          ends: delivery.ends,
          endDate: delivery.endDate,
          isDeliverToPharmacy: delivery.isDeliverToPharmacy,
          isAfter7pm,
          added_fee: deliveryCharges[idx].added_fee,
          requestId: delivery.requestId
        };
      });

      const res = await Axios.post(API_SUBMIT_ORDERS, { orders });
      if (!res.data) {
        throw new Error(t('orderSubmissionError'));
      }

      const { data } = res;
      const createdOrderResponse = data.data;
      if (data.status === 'success') {
        toast.dismiss(loadingToastId);
        toast.success(t('orderCreated'));

        if (printLabel) {
          const printData = [];
          deliveries.forEach((delivery, idx) => {
            const addressWithApptOrUnit = delivery.apptOrUnit
              ? `${delivery.address.address}, ${delivery.apptOrUnitType || t('unit')} ${delivery.apptOrUnit}`
              : delivery.address.address;

            const matchedOrder = createdOrderResponse.find(
              (o) => o.customerName === delivery.patientName
            );
            const storeOrderId = matchedOrder ? matchedOrder.storeOrderId : 'N/A';

            printData.push({
              ...delivery,
              address: addressWithApptOrUnit,
              phone: formatNumberCanadian(delivery.phone),
              storeOrderId,
              proofOfDelivery:
                delivery.proofOfDelivery === "rx" ? 'signature' : 'picture',
              isDeliverToPharmacy: delivery.isDeliverToPharmacy ? 'delivery' : 'dropoff'
            });
          });

          let printWindow = window.open('', '_blank', 'width=650,height=500');
          if (!printWindow) {
            toast.error(t('popupBlocked'));
            return;
          }

          printWindow.document.write('<html><head><title>' + t('shippingLabel') + '</title></head><body>');
          printWindow.document.write(`<style>body { margin: 0; font-size: 24px; } .label { height: 100vh; border: 1px solid black; padding: 20px; box-sizing: border-box; position: relative; } .bold { font-weight: bold; } .logo { position: absolute; bottom: 10px; right: 10px; width: 180px; } .pharmacy { text-align: center; font-size: 28px; } h2 { font-size: 32px; } h3 { font-size: 29px; } p { font-size: 26px; } @media print { @page { size: landscape; } }</style>`);

          printData.forEach((data) => {
            printWindow.document.write('<div class="label">');
            printWindow.document.write('<div class="pharmacy"><h2>' + Cookies.get('name') + '</h2></div>');
            printWindow.document.write('<p>' + t('patientName') + ': ' + data.patientName + '</p>');
            printWindow.document.write('<p>' + t('address') + ': ' + data.address + '</p>');
            printWindow.document.write('<p>' + t('phone') + ': ' + data.phone + '</p>');
            printWindow.document.write('<p>' + t('storeOrderId') + ': ' + data.storeOrderId + '</p>');

            if (data.numberOfPrescriptions) {
              printWindow.document.write(`<p>${t('numPrescriptions')}: ${data.numberOfPrescriptions}</p>`);
              for (let i = 1; i <= data.numberOfPrescriptions; i++) {
                const prescriptionNumber = data['prescriptionNumber' + i];
                if (prescriptionNumber) {
                  printWindow.document.write(`<p>- ${t('prescription')} ${i}: ${prescriptionNumber}</p>`);
                }
              }
            }
            if (data.scheduledDate) {
              printWindow.document.write(`<p>${t('scheduledDate')}: ${moment(data.scheduledDate).format('YYYY-MM-DD: hh:mm A')}</p>`);
            }
            printWindow.document.write(`<p class="bold">${t('deliveryNotes')}: ${data.deliveryNotes}</p>`);
            printWindow.document.write('<img id="logo" class="logo" src="' + Logo + '" width="150" />');
            printWindow.document.write('</div>');
          });

          printWindow.document.write('</body></html>');
          printWindow.document.close();

          const logo = printWindow.document.getElementById('logo');
          if (logo) {
            logo.onload = function () {
              printWindow.print();
            };
          } else {
            toast.error(t('logoError'));
          }
        }

        redirectPage();
        return;
      } else if (data.status === 'failure') {
        toast.dismiss(loadingToastId);
        if (data.error) {
          toast.error(data.error);
        } else {
          toast.error(t('invalidParams'));
        }
        return;
      }
    } catch (error) {
      toast.dismiss();
      console.error(t('submitError'), error);
      const errorMessage =
        (error && error.response && error.response.data && error.response.data.error) ||
        (error && error.message) ||
        t('unexpectedSubmitError');
      toast.error(errorMessage);
    } finally {
      setLoading(false);
      isSubmittingRef.current = false;
      toggle(false);
    }
  }

  if (!deliveryCharges || !Array.isArray(deliveryCharges) || deliveryCharges.length === 0) {
    return null;
  }

  const bgs = ['light', 'white'];
  const totalFee = total.toFixed(2);

  return (
    <Modal isOpen={modal} toggle={() => toggle(false)}>
      <ModalHeader>{t('reviewDeliveryTitle')}</ModalHeader>
      <ModalBody style={{ maxHeight: 'calc(100vh - 210px)', overflowY: 'auto' }}>
        <Container>
          {deliveries.filter((d) => d).map((delivery, idx) => (
            <div key={idx}>
              <ReviewItemUber
                bg={bgs[idx % bgs.length]}
                delivery={delivery}
                recurring={delivery.recurring}
                deliveryCharge={deliveryCharges && deliveryCharges[idx]}
              />
              <Row className="mb-3">
                <Col>
                  <div style={{ padding: '0.6rem', boxShadow: '0 4px 2px -2px rgba(0, 0, 0, 0.1)', marginTop: '1rem' }}>
                    <p><b>{t('expectedDelivery')}:</b> {t('withinOneHour')}</p>
                  </div>
                </Col>
              </Row>
            </div>
          ))}
          <br />
          <Row>
            <Col md={{ size: 3, offset: 9 }} className="bg-success pt-3 d-flex justify-content-end align-items-center">
              <h4 style={{ color: 'white', textAlign: 'end' }}>{t('totalFee')}: <b>${totalFee}</b></h4>
            </Col>
          </Row>
        </Container>
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={() => {
            if (loading) {
              toast.info(t('orderInProgress'));
              return;
            }
            if (invalidDeliveryCharge) {
              toast.warn(t('invalidChargeWarning'));
              return;
            }
            submitOrders(true);
          }}
          disabled={loading || invalidDeliveryCharge}
        >
          {t('submitPrint')}
        </Button>
        <Button
          color="primary"
          onClick={() => {
            if (loading) {
              toast.info(t('orderInProgress'));
              return;
            }
            if (invalidDeliveryCharge) {
              toast.warn(t('invalidChargeWarning'));
              return;
            }
            submitOrders(false);
          }}
          disabled={loading || invalidDeliveryCharge}
        >
          {t('submitOnly')}
        </Button>
        <Button color="secondary" onClick={() => toggle(false)}>
          {t('cancel')}
        </Button>
      </ModalFooter>
    </Modal>
  );
}

// A simpler "review item" row for Uber
function ReviewItemUber({ bg, delivery, deliveryCharge, recurring }) {
  const fee = deliveryCharge.fee;
  const price = getPriceWithoutTax(fee);
  return (
    <Row className={`pt-3 pb-3 bg-${bg} ${fee === 0 && 'bg-red'}`}>
      <Col md="9">
        <h3 style={{ marginBottom: 0, marginTop: 5 }}>
          {fee === 0
            ? `We're sorry, ${deliveryCharge.message}`
            : delivery.patientName}
        </h3>
        <p style={{ marginBottom: 0 }}>
          {delivery.apptOrUnit
            ? `${delivery.address.address}, ${delivery.apptOrUnitType || "Unit"} ${delivery.apptOrUnit
            }`
            : delivery.address.address}
        </p>
        {recurring && (
          <span
            style={{
              padding: 3,
              backgroundColor: '#FFBF00',
              color: 'white',
              borderRadius: 5,
              fontSize: 13,
              marginBottom: 10,
            }}
          >
            {this.props.t('nav.recurring')}
          </span>
        )}
      </Col>
      <Col md="3" className="d-flex justify-content-end align-items-center">
        <h1>${price}</h1>
      </Col>
    </Row>
  );
}

// ========== PUROLATOR REVIEW MODAL ==========
function PurolatorReviewModal({
  modal,
  toggle,
  deliveries,
  isAfter7pm,
  deliveryCharges,
  redirectPage,
  activeVendor,
  storePostalCode,
  storeProvince,
  lastScheduledDate
}) {
  if (typeof deliveryCharges === 'undefined') {
    deliveryCharges = 'non_response';
  }

  if (deliveryCharges === 'non_response') {
    return null;
  }

  if (!Array.isArray(deliveryCharges) || deliveryCharges.length === 0 || deliveryCharges.some(c =>
    typeof c !== 'object' ||
    c.kind !== 'delivery_quote' ||
    typeof c.fee !== 'number' ||
    c.fee === 0 ||
    typeof c.rate_id !== 'string' ||
    !c.rate_id.startsWith('se-')
  )) {
    // toast.error(
    //   "Vendor service is unavailable right now. Wait a few minutes and try again.",
    //   { toastId: 'purolatorDeliveryError', autoClose: 7000 }
    // );
    return null;
  }

  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const isSubmittingRef = useRef(false);

  let total = 0;
  if (deliveryCharges && Array.isArray(deliveryCharges)) {
    console.log("Delivery Charges:", deliveryCharges);
    total = deliveryCharges.reduce(
      (sum, { fee }) => sum + Number(getPriceWithoutTax(fee)),
      0
    );
  }

  if (
    !Array.isArray(deliveryCharges) ||
    deliveryCharges.length === 0 ||
    (deliveryCharges && deliveryCharges.some(
      (c) =>
        typeof c !== 'object' ||
        c.kind !== 'delivery_quote' ||
        typeof c.fee !== 'number' ||
        c.fee === 0
    ))
  ) {
    return null;
  }

  function hasScheduled(delivery) {
    return (
      delivery &&
      delivery.scheduled &&
      delivery.scheduled.length > 0
    );
  }

  function getScheduledDatePurolator(delivery, pharmacyTimeZone, lastScheduledDate) {


    const currentTimeInPharmacy = moment.tz(pharmacyTimeZone);
    const todayAtThreePM = currentTimeInPharmacy.clone().set({ hour: 15, minute: 0, second: 0, millisecond: 0 });
    const todayAtFourPM = currentTimeInPharmacy.clone().set({ hour: 16, minute: 0, second: 0, millisecond: 0 });
    const scheduledForTomorrow = currentTimeInPharmacy.clone().add(1, 'day').set({ hour: 15, minute: 0, second: 0, millisecond: 0 });

    if ((delivery.scheduled === undefined)) {
      if (currentTimeInPharmacy.isoWeekday() === 6) {
        toast.info(`The delivery has been scheduled for the next buisness day.`);

        return scheduledForTomorrow.add(1, 'days');
      } else if (currentTimeInPharmacy.isoWeekday() === 7) {
        toast.info(`The delivery has been scheduled for the next buisness day.`);
        return scheduledForTomorrow;
      }
      if (!lastScheduledDate && currentTimeInPharmacy.isBefore(todayAtThreePM)) {
        return todayAtThreePM;
      }
      else if (!lastScheduledDate && currentTimeInPharmacy.isAfter(todayAtThreePM)) {
        toast.info(`Your Pickup will be the scheduled for the next business day`);
        return scheduledForTomorrow;

      }
      const parsedLastScheduledDate = moment.tz(lastScheduledDate, pharmacyTimeZone);

      if (currentTimeInPharmacy.isBefore(todayAtFourPM)) {
        return parsedLastScheduledDate.isValid() ? parsedLastScheduledDate : todayAtThreePM;
      }

      toast.info(`Your Pickup will be the scheduled for the next business day`);

      return scheduledForTomorrow;
    }
    else {
      const parsedDate = moment(delivery.scheduledPurolatorDate);
      return parsedDate.isValid() ? parsedDate : null
    }

  };

  // ========== SUBMIT LOGIC FOR PUROLATOR ==========
  async function submitOrders(printLabel = false) {
    try {
      // Prevent rapid double submissions before state updates take effect
      if (isSubmittingRef.current) {
        toast.info(t("purolator.reviewModal.waiting"));
        return;
      }
      isSubmittingRef.current = true;
      setLoading(true);
      const loadingToastId = toast.info(t("purolator.submittingOrder"), { autoClose: false });

      const { API_CREATE_PUROLATOR_LABEL, SUBSCRIBE_WEBHOOK_PUROLATOR } = ApiUrl;
      const pharmacyTimeZone = getTimezone(storeProvince);

      const orders = deliveries.map((delivery, idx) => {
        if (
          delivery.recurring &&
          delivery.recurring.length > 0 &&
          !(delivery.ends && delivery.ends.length > 0)
        ) {
          const endDate = moment().add(6, 'months');
          delivery.ends = ['ends'];
          delivery.endDate = endDate.toISOString();
        }

        const prescriptionNumbers = getPrescriptionNumbers(delivery);
        const scheduledDate = getScheduledDatePurolator(delivery, pharmacyTimeZone, lastScheduledDate);
        const orderSubTotal = deliveryCharges[idx].fee;

        const packageCodeMapping = {
          envelope: "express_envelope",
          box: "express_box",
          pack: "express_pack",
        };
        const getPackageCode = (size) => packageCodeMapping[size] || undefined;
        const packageCode = getPackageCode(delivery.deliverySize);
        const addressParts = delivery.address.address.split(',').map((part) => part.trim());
        const country = addressParts.pop();
        const provincePostal = addressParts.pop();
        const [province, ...postalCodeParts] = provincePostal.split(' ');
        const postalCode = delivery.address.zipCode || postalCodeParts.join(' ');
        const city = addressParts.pop();
        const addressLine1 = addressParts.join(', ');

        return {
          phone: delivery.phone,
          address: delivery.address.address,
          zipCode: delivery.address.zipCode,
          patientName: delivery.patientName,
          apptOrUnitType: delivery.apptOrUnitType,
          apptOrUnit: delivery.apptOrUnit,
          proofOfDelivery: delivery.proofOfDeliveryPurolator,
          proofOfReturnDelivery: delivery.proofOfReturnDelivery,
          proofOfPickup: delivery.proofOfPickup,
          numberOfPrescriptions: delivery.numberOfPrescriptions,
          prescriptionNumbers,
          storePostalCode,
          deliveryFee: orderSubTotal.toFixed(2),
          pharmacyId: Cookies.get('_id'),
          companyName: delivery.companyName,
          scheduled: delivery.scheduled,
          scheduledDate: scheduledDate ? scheduledDate.toISOString() : "",
          ship_to: {
            name: delivery.patientName,
            email: delivery.patientEmail,
            phone: delivery.phone,
            companyName: delivery.companyName,
            address_line1: addressLine1,
            city_locality: city,
            state_province: province,
            postal_code: postalCode,
            country_code: country.toLowerCase() === "canada" ? "CA" : country,
            address_residential_indicator: delivery.isDeliverToPharmacy ? "no" : "yes",
          },
          nextRecurrenceDate: delivery.nextRecurrenceDate,
          costs: delivery.costs,
          recurring: delivery.recurring,
          recurrence: delivery.recursion,
          customRecurringDays: delivery.customRecurringDays,
          customRecurringDaysOrderTime: delivery.customRecurringDaysOrderTime,
          ends: delivery.ends,
          endDate: delivery.endDate,
          isDeliverToPharmacy: delivery.isDeliverToPharmacy,
          rate_id: deliveryCharges[idx].rate_id,
          fuelFee: deliveryCharges[idx].fuelFee,
          firstPrice: deliveryCharges[idx].carrierFee,
          costTotal: deliveryCharges[idx].fee,
          added_fee: deliveryCharges[idx].added_fee,
          packages: Array.from(
            {
              length:
                delivery.packageOption === "multiple"
                  ? parseInt(delivery.numberOfPackagesSelect || 1)
                  : 1
            },
            () => ({
              ...(packageCode
                ? { package_code: packageCode }
                : {
                  dimensions: {
                    height: parseFloat(delivery.customHeight) || 0,
                    width: parseFloat(delivery.customWidth) || 0,
                    length: parseFloat(delivery.customLength) || 0,
                    unit: delivery.dimensionUnit || "inch"
                  }
                }),
              weight: {
                value: parseFloat(delivery.customWeight) || 0,
                unit: delivery.weightUnit || "pound"
              }
            })
          )
        };
      });

      const res = await Axios.post(API_CREATE_PUROLATOR_LABEL, { orders });
      if (!res.data) throw new Error(t('purolator.submitFailed'));

      const { data } = res;
      const createdOrderResponsePurolator = data.deliveries;

      if (data.status === 'success' || data.status === 'partial') {
        if (createdOrderResponsePurolator.length) {
          const pharmacyId = Cookies.get('_id');
          if (!pharmacyId) throw new Error(t('purolator.missingPharmacyId'));

          for (let i = 0; i < createdOrderResponsePurolator.length; i++) {
            const order = createdOrderResponsePurolator[i];
            const trackingNumber = order.trackingUrl;
            if (!trackingNumber) throw new Error(t('purolator.missingTrackingNumber', { index: i + 1 }));

            try {
              await Axios.post(ApiUrl.SUBSCRIBE_WEBHOOK_PUROLATOR, {
                trackingNumber,
                pharmacyId
              });
            } catch (error) {
              console.error(t('purolator.webhookFailed', { index: i + 1 }), error);
              throw new Error(t('purolator.webhookError', { index: i + 1 }));
            }
          }
        }

        toast.dismiss(loadingToastId);
        if (data.status === 'partial' && Array.isArray(data.failedOrders) && data.failedOrders.length > 0) {
          const failedNames = data.failedOrders.map((f) => f.patientName || `#${f.index + 1}`).join(', ');
          toast.warn(t('purolator.partialOrderSuccess', { count: data.failedOrders.length, names: failedNames }));
        } else {
          toast.success(t('purolator.orderSuccess'));
        }

        if (printLabel) {
          const printWindow = window.open('', '_blank', 'width=800,height=600');
          if (!printWindow) {
            toast.error(t('purolator.printError'));
            return;
          }

          printWindow.document.write('<html><head><title>Print PDFs</title></head><body>');
          printWindow.document.write('<style>iframe { width: 100%; height: 100%; border: none; }</style>');

          deliveries.forEach((delivery) => {
            const found = createdOrderResponsePurolator.find(
              (o) => o.customerName === delivery.patientName
            );
            const deliveryPdf = found ? found.orderUrl : null;
            if (deliveryPdf) {
              printWindow.document.write(`
              <iframe src="${deliveryPdf}"
                onload="this.style.height = this.contentWindow.document.body.scrollHeight + 'px';"
              ></iframe>
            `);
            }
          });

          printWindow.document.write('</body></html>');
          printWindow.document.close();
          printWindow.onload = () => {
            printWindow.print();
          };
        }

        redirectPage();
      } else if (data.status === 'failure') {
        toast.dismiss(loadingToastId);
        toast.error(data.error || t('purolator.invalidParameters'));
      }
    } catch (error) {
      toast.dismiss();
      console.error('Error during order submission (Purolator):', error);
      const errorMessage =
        error.response && error.response.data && error.response.data.error ||
        error.message ||
        error ||
        t('purolator.unexpectedError');
      toast.error(errorMessage);
    } finally {
      setLoading(false);
      isSubmittingRef.current = false;
      toggle(false);
    }
  }

  if (!deliveryCharges || !Array.isArray(deliveryCharges) || deliveryCharges.length === 0) {
    return null;
  }

  const bgs = ['light', 'white'];
  const totalFee = total.toFixed(2);
  const getNextWeekday = (date) => {
    const day = date.getDay();
    if (day === 6) {
      date.setDate(date.getDate() + 2);
    } else if (day === 0) {
      date.setDate(date.getDate() + 1);
    }
    return date;
  };

  return (
    <Modal isOpen={modal} toggle={() => toggle(false)}>
      <ModalHeader>{t('purolator.reviewModal.title')}</ModalHeader>
      <ModalBody style={{ maxHeight: 'calc(100vh - 210px)', overflowY: 'auto' }}>
        <Container>
          {deliveries.filter((d) => d).map((delivery, idx) => (
            <div key={idx}>
              <ReviewItemPurolator
                bg={bgs[idx % bgs.length]}
                delivery={delivery}
                recurring={delivery.recurring}
                deliveryCharge={deliveryCharges && deliveryCharges[idx]}
              />
              <Row className="mb-3">
                <Col>
                  <div
                    style={{
                      padding: '0.6rem',
                      boxShadow: '0 4px 2px -2px rgba(0, 0, 0, 0.1)',
                      marginTop: '1rem',
                    }}
                  >
                    <p>
                      <b>{t('purolator.reviewModal.expectedDelivery')}:</b>{" "}
                      {deliveryCharges &&
                        deliveryCharges && deliveryCharges[idx] &&
                        deliveryCharges[idx].estimated_delivery_date ? (
                        (() => {
                          const baseDate = new Date(deliveryCharges[idx].estimated_delivery_date);
                          if (delivery.scheduledPurolatorDate) {
                            const scheduledDate = new Date(delivery.scheduledPurolatorDate);
                            const dateDifference = Math.floor(
                              (scheduledDate - baseDate) / (1000 * 60 * 60 * 24)
                            );
                            const adjustedDate = new Date(baseDate);
                            adjustedDate.setDate(adjustedDate.getDate() + dateDifference + 1);
                            const returnDate =
                              dateDifference < 0
                                ? new Date(deliveryCharges[idx].estimated_delivery_date)
                                : adjustedDate;
                            const finalDate = getNextWeekday(returnDate);
                            return finalDate.toISOString().split("T")[0];
                          }
                          return baseDate.toISOString().split("T")[0];
                        })()
                      ) : (
                        t('purolator.reviewModal.notAvailable')
                      )}
                    </p>
                  </div>
                </Col>
              </Row>
            </div>
          ))}
          <br />
          <Row>
            <Col
              md={{ size: 3, offset: 9 }}
              className="bg-success pt-3 d-flex justify-content-end align-items-center"
            >
              <h4 style={{ color: 'white', textAlign: 'end' }}>
                {t('purolator.reviewModal.totalFee')} : <b>${totalFee}</b>
              </h4>
            </Col>
          </Row>
        </Container>
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={() => {
            if (loading) {
              toast.info(t('purolator.reviewModal.waiting'));
              return;
            }

            submitOrders(true);
          }}
          disabled={loading}
        >
          {t('purolator.reviewModal.submitAndPrint')}
        </Button>
        <Button
          color="primary"
          onClick={() => {
            if (loading) {
              toast.info(t('purolator.reviewModal.waiting'));
              return;
            }
            submitOrders(false);
          }}
          disabled={loading}
        >
          {t('purolator.reviewModal.submitOnly')}
        </Button>
        <Button color="secondary" onClick={() => toggle(false)}>
          {t('purolator.reviewModal.cancel')}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
function ReviewItemPurolator({ bg, delivery, deliveryCharge, recurring }) {
  const fee = deliveryCharge.fee;
  const price = getPriceWithoutTax(fee);

  return (
    <Row className={`pt-3 pb-3 bg-${bg} ${fee === 0 && 'bg-red'}`}>
      <Col md="9">
        <h3 style={{ marginBottom: 0, marginTop: 5 }}>
          {fee === 0
            ? `We're sorry, ${deliveryCharge.message}`
            : delivery.patientName}
        </h3>
        <p style={{ marginBottom: 0 }}>
          {delivery.apptOrUnit
            ? `${delivery.address.address}, ${delivery.apptOrUnitType || "Unit"} ${delivery.apptOrUnit
            }`
            : delivery.address.address}
        </p>
        {recurring && (
          <span
            style={{
              padding: 3,
              backgroundColor: '#FFBF00',
              color: 'white',
              borderRadius: 5,
              fontSize: 13,
              marginBottom: 10,
            }}
          >
            {this.props.t('nav.recurring')}
          </span>
        )}
      </Col>
      <Col md="3" className="d-flex justify-content-end align-items-center">
        <h1>${price}</h1>
      </Col>
    </Row>
  );
}

// ========== MYRX REVIEW MODAL ==========
function ReviewItemMyRx({ bg, delivery, deliveryCharge, recurring }) {
  const fee = deliveryCharge.fee;
  const price = getPriceWithoutTax(fee);

  return (
    <Row className={`pt-3 pb-3 bg-${bg} ${fee === 0 && 'bg-red'}`}>
      <Col md="9">
        <h3 style={{ marginBottom: 0, marginTop: 5 }}>{delivery.patientName}</h3>
        <p style={{ marginBottom: 0 }}>{delivery.address.address}</p>
      </Col>
      <Col md="3" className="d-flex justify-content-end align-items-center">
        <h1>${price}</h1>
      </Col>
    </Row>
  );
}



export function MyRxReviewModal({ modal, toggle, deliveries, deliveryCharges, redirectPage }) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const isSubmittingRef = useRef(false);
  const bgs = ['light', 'white'];

  let total = 0;
  if (Array.isArray(deliveryCharges)) {
    total = deliveryCharges.reduce(
      (sum, { fee }) => sum + Number(getPriceWithoutTax(fee)),
      0
    );
  }

  async function submitOrders() {
    try {
      if (isSubmittingRef.current) {
        toast.info(t('orderInProgress'));
        return;
      }
      isSubmittingRef.current = true;
      setLoading(true);
      const toastId = toast.info(t('myrx.submitting'), { autoClose: false });

      const enrichedOrders = deliveries.map((delivery, idx) => ({
        ...delivery,
        pharmacyId: Cookies.get('_id'),
        deliveryFee: deliveryCharges[idx].fee || 0,
        added_fee: deliveryCharges[idx].added_fee || 0,
      }));

      const res = await Axios.post(API_CREATE_MYRX_CREATE_ORDER, { data: enrichedOrders });
      if (res.data.status === 'success') {
        toast.dismiss(toastId);
        toast.success(t('myrx.success'));
        let newWindow = null;

        if (res.data.pdfBase64) {
          const byteArray = Uint8Array.from(atob(res.data.pdfBase64), c => c.charCodeAt(0));
          const blob = new Blob([byteArray], { type: 'application/pdf' });
          const blobUrl = URL.createObjectURL(blob);
          newWindow = window.open(blobUrl, '_blank');
        }

        redirectPage();

        if (!newWindow) {
          const ua = navigator.userAgent;
          let helpLink = 'https://support.google.com/chrome/answer/95472';

          if (/Firefox/i.test(ua)) helpLink = 'https://support.mozilla.org/en-US/kb/pop-blocker-settings';
          else if (/Edg/i.test(ua)) helpLink = 'https://support.microsoft.com/en-ca/topic/block-pop-ups-in-microsoft-edge-3a8f6caf-0c9d-7a22-eed6-d0d73e5df9fd';
          else if (/Safari/i.test(ua) && !/Chrome|Edg/i.test(ua)) helpLink = 'https://support.apple.com/en-ca/guide/safari/ibrw1072/mac';
          else if (/OPR|Opera/i.test(ua)) helpLink = 'https://help.opera.com/en/latest/web-preferences/#popups';
          else if (/SamsungBrowser/i.test(ua)) helpLink = 'https://www.samsung.com/ca/support/mobile-devices/how-to-enable-pop-ups-in-samsung-internet/';

          toast.error(
            <>
              {t('myrx.popup_blocked')}{' '}
              <a href={helpLink} target="_blank" rel="noopener noreferrer">{t('myrx.enable_popups')}</a>{' '}
              {t('myrx.access_label')}
            </>,
            { autoClose: 10000, closeOnClick: false, pauseOnHover: true }
          );
        }
      } else {
        throw new Error(res.data.error || t('myrx.failure'));
      }
    } catch (err) {
      console.error('[MyRxReviewModal] Error:', err);
      toast.error(err.message || t('myrx.failure'));
    } finally {
      setLoading(false);
      isSubmittingRef.current = false;
      toggle(false);
    }
  }

  if (!Array.isArray(deliveryCharges) || deliveryCharges.length === 0) return null;

  return (
    <Modal isOpen={modal} toggle={() => toggle(false)}>
      <ModalHeader>{t('myrx.review_title')}</ModalHeader>
      <ModalBody style={{ maxHeight: 'calc(100vh - 210px)', overflowY: 'auto' }}>
        <Container>
          {deliveries.map((delivery, idx) => (
            <ReviewItemMyRx
              key={idx}
              bg={bgs[idx % bgs.length]}
              delivery={delivery}
              deliveryCharge={deliveryCharges && deliveryCharges[idx]}
            />
          ))}
          <br />
          <Row className="mb-3">
            <Col>
              <div style={{ padding: '0.6rem', boxShadow: '0 4px 2px -2px rgba(0,0,0,0.1)', marginTop: '1rem' }}>
                <p>
                  <b>{t('myrx.expected_delivery')}</b>{' '}
                  {deliveryCharges && deliveryCharges[0] && (deliveryCharges[0].deliveryWindow || deliveryCharges[0].message)}.<br />
                  <b>{t('myrx.min_deliveries')}</b>
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={{ size: 3, offset: 9 }} className="bg-success pt-3 d-flex justify-content-end align-items-center">
              <h4 style={{ color: 'white', textAlign: 'end' }}>
                {t('myrx.total_fee')} <b>${total.toFixed(2)}</b>
              </h4>
            </Col>
          </Row>
        </Container>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={submitOrders} disabled={loading || total <= 0}>
          {t('myrx.submit_and_print')}
        </Button>
        <Button color="secondary" onClick={() => toggle(false)}>
          {t('common.cancel')}
        </Button>
      </ModalFooter>
    </Modal>
  );
}




// ========== GOLIVRO REVIEW MODAL ==========
function ReviewItemGolivro({ bg, delivery, deliveryCharge }) {
  const fee = deliveryCharge.fee;
  const price = getPriceWithoutTax(fee);

  return (
    <Row className={`pt-3 pb-3 bg-${bg} ${fee === 0 && 'bg-red'}`}>
      <Col md="9">
        <h3 style={{ marginBottom: 0, marginTop: 5 }}>
          {fee === 0
            ? `We're sorry, ${deliveryCharge.message}`
            : delivery.patientName}
        </h3>
        <p style={{ marginBottom: 0 }}>
          {delivery.apptOrUnit
            ? `${delivery.address.address}, ${delivery.apptOrUnitType || "Unit"} ${delivery.apptOrUnit}`
            : delivery.address.address}
        </p>
        {delivery.service && (
          <span style={{
            padding: 3,
            backgroundColor: '#28a745',
            color: 'white',
            borderRadius: 5,
            fontSize: 13,
            marginTop: 5,
            display: 'inline-block'
          }}>
            {delivery.service.toUpperCase()}
          </span>
        )}
      </Col>
      <Col md="3" className="d-flex justify-content-end align-items-center">
        <h1>${price}</h1>
      </Col>
    </Row>
  );
}

export function GolivroReviewModal({ modal, toggle, deliveries, deliveryCharges, redirectPage, storePostalCode }) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const isSubmittingRef = useRef(false);
  const bgs = ['light', 'white'];

  // Fixed tax rate for Golivro (14.975%)
  const GOLIVRO_TAX_RATE = 14.975;

  let total = 0;
  if (Array.isArray(deliveryCharges)) {
    total = deliveryCharges.reduce(
      (sum, { fee }) => sum + Number(getPriceWithoutTax(fee)),
      0
    );
  }

  const invalidDeliveryCharge = deliveryCharges && Array.isArray(deliveryCharges) && deliveryCharges.some(
    ({ fee }) => !fee || Number(fee) === 0
  );

  async function submitOrders(printLabel = false) {
    if (isSubmittingRef.current) return;
    isSubmittingRef.current = true;
    setLoading(true);

    // 1) Pre-open labels window synchronously (popup-safe)
    var labelsWin = null;
    if (printLabel) {
      labelsWin = window.open("", "_blank");
      if (labelsWin) {
        labelsWin.document.open();
        labelsWin.document.write(`
        <html>
          <head>
            <title>Delivery Labels</title>
            <meta charset="utf-8" />
            <style>
              body { font-family: Arial, sans-serif; padding: 12px; margin: 0; }
              h3 { margin: 0 0 8px; }
              .muted { color: #666; font-size: 13px; }
            </style>
          </head>
          <body>
            <h3>Delivery Labels</h3>
            <div class="muted">Loading labels…</div>
          </body>
        </html>
      `);
        labelsWin.document.close();
      } else {
        toast.error(t("golivro.popup_blocked", "Popup blocked. Please allow popups to view labels."));
      }
    }

    try {
      var ordersToSubmit = deliveries.map(function (delivery, idx) {
        var deliveryCharge = deliveryCharges[idx] || {};
        // const { lat, lng } = await getCoordinates(delivery.patientAddress);
        // const coordinates = {
        //   latitude: lat,
        //   longitude: lng
        // }

        return {
          pharmacyId: Cookies.get("_id"),
          ship_to: {
            name: delivery.patientName,
            phone: delivery.phone,
            city_locality: (delivery.address && delivery.address.city) || "Montreal",
            state_province: "QC",
            postal_code: delivery.address && delivery.address.zipCode,
            coordinates: {
              latitude: delivery.address && delivery.address.lat,
              longitude: delivery.address && delivery.address.lng,
            },
            country_code: "CA",
          },
          address: delivery.address && delivery.address.address,
          deliveryFee: deliveryCharge.fee,
          patientName: delivery.patientName,
          proofOfDelivery: delivery.proofOfDelivery || "otc",
          apptOrUnit: delivery.apptOrUnit || "",
          apptOrUnitType: delivery.apptOrUnitType || "Apt",
          storePostalCode: storePostalCode,
          // ASAP orders send no date: Golivro books the first pickup slot its cutoff allows
          scheduledDate: (delivery.scheduled && delivery.scheduledDate) || null,
          service: delivery.service || "fast",
          size: delivery.size || "envelope",
          paymentMethod: delivery.paymentMethod || "already_paid",
          amount: delivery.amount || 0,
          packageCount: delivery.packageCount || 1,
          deliveryNotes: delivery.deliveryNotes || "",
          pickupNotes: delivery.pickupNotes || "",
          companyName: delivery.companyName || "",
          isDeliverToPharmacy: delivery.isDeliverToPharmacy || false,
          proofOfReturnDelivery: delivery.proofOfReturnDelivery || "rx",
          golivrofees:
            deliveryCharge.breakdown && deliveryCharge.breakdown.mowFeeCents,
          costs: delivery.costs,
        };
      });

      var response = await Axios.post(
        API_CREATE_GOLIVRO_DELIVERY,
        { orders: ordersToSubmit },
        {
          headers: {
            token: Cookies.get("token"),
            restaurantid: Cookies.get("_id"),
          },
        }
      );

      // 2) SUCCESS handling (independent from printLabel)
      if (response && response.data && response.data.status === "success") {
        toast.success(t("golivro.order_created_success"));

        // 3) Optional label rendering
        if (printLabel) {
          var urls = [];

          if (response.data.deliveries && Array.isArray(response.data.deliveries)) {
            urls = response.data.deliveries
              .map(function (d) {
                return d && d.orderUrl;
              })
              .filter(Boolean);
          }

          if (!urls.length) {
            toast.error(
              t(
                "golivro.no_labels_returned",
                "Orders created, but no label URLs were returned."
              )
            );

            if (labelsWin && !labelsWin.closed) {
              labelsWin.document.open();
              labelsWin.document.write(
                '<p style="font-family:Arial;padding:12px">No labels returned.</p>'
              );
              labelsWin.document.close();
            }
          } else if (labelsWin && !labelsWin.closed) {
            labelsWin.document.open();
            labelsWin.document.write(`
            <html>
              <head>
                <title>Delivery Labels</title>
                <meta charset="utf-8" />
                <style>
                  body { font-family: Arial, sans-serif; padding: 12px; margin: 0; }
                  h3 { margin: 0 0 10px; }
                  .muted { color: #666; font-size: 13px; margin-bottom: 12px; }
                  .label { margin: 14px 0; padding: 10px; border: 1px solid #e5e5e5; border-radius: 8px; }
                  .label a { word-break: break-all; }
                  iframe { width: 100%; height: 85vh; border: 0; margin-top: 8px; }
                </style>
              </head>
              <body>
                <h3>Delivery Labels</h3>
                <div class="muted">
                  If a label does not render, use the link to open it in a new tab.
                </div>

                ${urls
                .map(function (u, i) {
                  return `
                      <div class="label">
                        <div><strong>Label ${i + 1}</strong> —
                          <a href="${u}" target="_blank" rel="noopener noreferrer">${u}</a>
                        </div>
                        <iframe src="${u}"></iframe>
                      </div>
                    `;
                })
                .join("")}
              </body>
            </html>
          `);
            labelsWin.document.close();
          } else {
            // fallback
            window.open(urls[0], "_blank");
          }
        }

        // 4) Continue normal UI flow
        if (typeof toggle === "function") toggle(false);
        if (typeof redirectPage === "function") redirectPage();

        return response.data;
      }

      toast.error(
        (response && response.data && response.data.message) ||
        t("golivro.order_creation_failed")
      );
      return null;
    } catch (error) {
      console.error("Error creating Golivro orders:", error);
      toast.error(
        (error &&
          error.response &&
          error.response.data &&
          (error.response.data.error || error.response.data.message)) ||
        t("golivro.order_creation_error")
      );

      if (labelsWin && !labelsWin.closed) {
        labelsWin.document.open();
        labelsWin.document.write(`
        <html>
          <body style="font-family:Arial;padding:12px">
            <h3>Delivery Labels</h3>
            <p>Failed to load labels because order creation failed.</p>
          </body>
        </html>
      `);
        labelsWin.document.close();
      }

      return null;
    } finally {
      setLoading(false);
      isSubmittingRef.current = false;
    }
  }


  if (!Array.isArray(deliveryCharges) || deliveryCharges.length === 0) {
    return null;
  }

  return (
    <Modal isOpen={modal} toggle={() => toggle(false)}>
      <ModalHeader>{t('golivro.review_title') || 'Review Golivro Deliveries'}</ModalHeader>
      <ModalBody style={{ maxHeight: 'calc(100vh - 210px)', overflowY: 'auto' }}>
        <Container>
          {deliveries.filter((d) => d).map((delivery, idx) => (
            <div key={idx}>
              <ReviewItemGolivro
                bg={bgs[idx % bgs.length]}
                delivery={delivery}
                deliveryCharge={deliveryCharges && deliveryCharges[idx]}
              />
              {/* <Row className="mb-3">
                <Col>
                  <div style={{ padding: '0.6rem', boxShadow: '0 4px 2px -2px rgba(0, 0, 0, 0.1)', marginTop: '1rem' }}>
                    <p>
                      <b>{t('golivro.expected_delivery')}:</b>{' '}
                      {deliveryCharges && deliveryCharges[idx] && deliveryCharges[idx].duration
                        ? `${deliveryCharges[idx].duration} minutes`
                        : t('golivro.varies_by_service')}
                    </p>
                    {delivery.scheduled && delivery.scheduledDate && (
                      <p>
                        <b>{t('golivro.scheduled_for')}:</b>{' '}
                        {moment(delivery.scheduledDate).format('MMMM DD, YYYY [at] h:mm A')}
                      </p>
                    )}
                  </div>
                </Col>
              </Row> */}
            </div>
          ))}
          <br />
          {/* <Row className="mb-2">
            <Col>
              <div style={{
                padding: '0.8rem',
                backgroundColor: '#f8f9fa',
                borderRadius: '4px',
                border: '1px solid #dee2e6'
              }}>
                <p style={{ marginBottom: '0.5rem', fontSize: '14px' }}>
                  <b>{t('golivro.tax_info')}:</b> {t('golivro.tax_rate_message') || `Tax rate: ${GOLIVRO_TAX_RATE}% (Montreal)`}
                </p>
                <p style={{ marginBottom: 0, fontSize: '12px', color: '#6c757d' }}>
                  {t('golivro.montreal_only_message') || 'Golivro delivers in Montreal only'}
                </p>
              </div>
            </Col>
          </Row> */}
          <Row>
            <Col md={{ size: 3, offset: 9 }} className="bg-success pt-3 d-flex justify-content-end align-items-center">
              <h4 style={{ color: 'white', textAlign: 'end' }}>
                {t('golivro.total_fee') || 'Total'}: <b>${total.toFixed(2)}</b>
              </h4>
            </Col>
          </Row>
        </Container>
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={() => submitOrders(true)}
          disabled={loading || invalidDeliveryCharge}
        >
          {t('golivro.submit_and_print') || 'Submit & Print'}
        </Button>
        {/* <Button
          color="primary"
          onClick={() => submitOrders(false)}
          disabled={loading || invalidDeliveryCharge}
        >
          {t('golivro.submit_only') || 'Submit Only'}
        </Button> */}
        <Button color="secondary" onClick={() => toggle(false)}>
          {t('common.cancel') || 'Cancel'}
        </Button>
      </ModalFooter>
    </Modal>
  );
}


// ========== MAIN ReviewModal THAT SWITCHES BASED ON activeVendor ==========
export default function ReviewModal(props) {
  const { activeVendor } = props;
  const [pharmacyLoaded, setPharmacyLoaded] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (!Cookies.get("province")) {
      fetchPharmacyDetails().then(() => setPharmacyLoaded(true));
    } else {
      setPharmacyLoaded(true);
    }
  }, []);

  if (!pharmacyLoaded) {
    return <p>{t('loading.loadingpharmacy')}</p>;
  }


  if (activeVendor === 'Uber') {
    return <UberReviewModal {...props} />;
  } else if (activeVendor === 'myRx') {
    return <MyRxReviewModal {...props} />;
  } else if (activeVendor === 'Golivro') {
    return <GolivroReviewModal {...props} />;
  } else {
    return <PurolatorReviewModal {...props} />;
  }
}



export function getPriceWithTax(total) {

  const provinceTax = provinceTaxes[Cookies.get('province')] ? provinceTaxes[Cookies.get('province')] : 0;

  return total * (1 + provinceTax / 100);
}